/**
 * These values are the single source of truth for Tailwind and the MUI theme.
 *
 * Verified ramp-for-ramp against the Figma palette frame (node `15135:16450`) on 2026-09-21. Two
 * names differ from Figma's and are not drift: `neutrals` is Figma's `gray` (MUI's own key is `grey`,
 * and the Tailwind utilities are `*-neutrals-*`), and `warning` is Figma's `amber`.
 *
 * One Figma variable is mislabelled, and reading it literally corrupts two ramps: `critical-950`
 * (`#451A03`) is **amber's** 950 — the amber ramp otherwise stops at 900, and the real value is
 * `critical/950` (`#1C030B`). Both are already correct below.
 */

export const colors = {
  white: "#FFFFFF",
  navy: {
    50: "#F5F8FA",
    100: "#E1E7EF",
    200: "#C0CBD8",
    300: "#8EA4BE",
    400: "#6D8AAB",
    500: "#506D95",
    600: "#315381",
    700: "#184072",
    800: "#002D5D",
    900: "#00254C",
    950: "#001933",
  },
  aqua: {
    50: "#E9FBF8",
    100: "#C6F5ED",
    200: "#84ECDC",
    300: "#20DFC5",
    400: "#1BC1AD",
    500: "#149F91",
    600: "#0D736A",
    700: "#0C554D",
    800: "#093E37",
    900: "#08352E",
    950: "#020E0D",
  },
  blue: {
    50: "#F0FBFF",
    100: "#E6F9FF",
    200: "#CCF1FF",
    300: "#99E3FF",
    400: "#66D4FF",
    500: "#2CC1F2",
    600: "#0BA1D8",
    700: "#007AAB",
    800: "#005B80",
    900: "#003F5C",
    950: "#002D42",
  },
  lime: {
    50: "#F8FFE3",
    100: "#EDFFB8",
    200: "#DDF88B",
    300: "#CCEE63",
    400: "#B6DE3A",
    500: "#98C804",
    600: "#8BB800",
    700: "#739900",
    800: "#618001",
    900: "#455B01",
    950: "#303D0A",
  },
  neutrals: {
    50: "#F9FAFB",
    100: "#F3F4F6",
    200: "#E5E7EB",
    300: "#D1D5DB",
    400: "#9CA3AF",
    500: "#6B7280",
    600: "#4B5563",
    700: "#374151",
    800: "#1F2937",
    900: "#111827",
    950: "#030712",
  },
  success: {
    50: "#F5FDF0",
    100: "#E9FCDC",
    200: "#D3F7BB",
    300: "#ADEF86",
    400: "#80DE4A",
    500: "#5EC522",
    600: "#4AA316",
    700: "#3C8015",
    800: "#306516",
    900: "#214A12",
    950: "#0D2904",
  },
  warning: {
    50: "#FFFBEB",
    100: "#FEF3C7",
    200: "#FDE68A",
    300: "#FCD34D",
    400: "#FBBF24",
    500: "#F59E0B",
    600: "#D97706",
    700: "#B45309",
    800: "#92400E",
    900: "#78350F",
    950: "#451A03",
  },
  critical: {
    50: "#FDECF2",
    100: "#FBD5E1",
    200: "#FFBDD2",
    300: "#F282A6",
    400: "#EF5D8B",
    500: "#EA336D",
    600: "#D91655",
    700: "#B30039",
    800: "#6B0B29",
    900: "#380615",
    950: "#1C030B",
  },
  violet: {
    50: "#F5F3FF",
    100: "#EDE9FE",
    200: "#DDD6FE",
    300: "#C4B5FD",
    400: "#A78BFA",
    500: "#8B5CF6",
    600: "#7C3AED",
    700: "#6D28D9",
    800: "#5B21B6",
    900: "#4C1D95",
    950: "#2E1065",
  },
};
